import React from "react"

type Props = {
  height?: string
  width?: string
}

const IconBack: React.FC<Props> = ({ height, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="ionicon"
      viewBox="0 0 512 512"
      height={height || "20px"}
      width={width || "20px"}
    >
      <title>Chevron Back</title>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="48"
        d="M328 112L184 256l144 144"
      />
    </svg>
  )
}

export default IconBack
